export const MAIL_APP_ACTIONS = {
    SET_SELECTED_ITEMS: "set-selected-items",
    SET_MAILS_LIST_REFRESH: "set-mails-list-refresh",
    SET_LABELS_LIST_REFRESH: "set-labels-list-refresh",
};
